declare var require;

export class AnimationContents {
  public static FULLSCREEN_JSON = require('../animate/Fullscreen.json');
  public static ORIENTATION_SCREEN_JSON = require('../animate/OrientationScreen.json');

  public static GAME_SCREEN_JSON = require('../animate/GameScreen.json');
  public static PRELOADER_SCREEN_JSON = require('../animate/PreloaderScreen.json');
  public static AFTERLOADER_SCREEN_JSON = require('../animate/LoaderScreen.json');
  public static DIALOG_SCREEN_JSON = require('../animate/DialogScreen.json');
  public static HURRYUP_SCREEN_JSON = require('../animate/HurryUpDialog.json');
  public static CHARACTER_SCREEN_JSON = require('../animate/CharacterScreen.json');
  public static END_SCREEN_JSON = require('../animate/EndScreen.json');

  public static MINIMAP_SCREEN_JSON = require('../animate/MiniMapScreen.json');
  public static INFO_SCREEN_JSON = require('../animate/InfoScreen.json');
  public static TASK_LIST_SCREEN_JSON = require('../animate/TaskListScreen.json');

  // Mini games
  public static ROPES_GAME_SCREEN_JSON = require('../animate/RopesGame.json');
  public static LASER_GAME_SCREEN_JSON = require('../animate/LaserGame.json');
  public static ENGINE_GAME_SCREEN_JSON = require('../animate/EngineGame.json');
  public static RESCUE_GAME_SCREEN_JSON = require('../animate/RescueGame.json');
  public static PROPS_GAME_SCREEN_JSON = require('../animate/PropsGame.json');
  public static PROPS_PROGRESSBAR_JSON = require('../animate/PropsProgressbar.json');
  public static EXIT_BUTTON_JSON = require('../animate/ExitButton.json');
}
